<template>
    <DashboardLayout
        :me="me"
        :sidebar-title="sidebarTitle"
        :sidebar-short-title="sidebarShortTitle"
        :sidebar-links="sidebarLinks"
        :sidebar-background="sidebarBackground"
        :hide-footer="$route.meta.hideFooter"
        :footer-website="footerWebsite"
        :footer-company="footerCompany"
        :footer-year="footerYear"
        :delivery-request-customer="deliveryRequestCustomer"
        :delivery-request-modal-visible="showModal"
        @showDeliveryRequestModal="showModal = true"
        @logout="logout"
        @switchAccount="switchAccount"
    >
        <new-delivery-request
            v-if="pendingReceiptLogs.length"
            :receipt-logs="pendingReceiptLogs"
            :show.sync="showModal"
            @cancel="cancelDeliveryRequest"
        />
    </DashboardLayout>
</template>

<script>
import { mapState, mapActions } from "vuex";
import routes from "src/router/routes";
import NewDeliveryRequest from "src/modules/DeliveryRequest/NewDeliveryRequest";
import DashboardLayout from "./_components/DashboardLayout";
import api from "src/services/api.js";
import { store, mutations } from "src/global-store.js";

export default {
    name: "DashboardModule",
    components: {
        DashboardLayout,
        NewDeliveryRequest,
    },
    data() {
        return {
            footerWebsite: "https://www.exnihilodev.com",
            footerCompany: "Ex Nihilo Studios",
            footerYear: new Date().getFullYear(),
            sidebarTitle: "Delivery By Design",
            sidebarShortTitle: "DBD",
            sidebarBackground: "primary", // vue|blue|orange|green|red|primary
        };
    },
    computed: {
        me: {
            get() {
                return store.me;
            },
            set(val) {
                mutations.setMe(val);
            },
        },
        ...mapState("deliveryRequest", [
            "pendingReceiptLogs",
            "requestDeliveryModalVisible",
        ]),
        deliveryRequestCustomer() {
            return this.pendingReceiptLogs[0]?.customer?.name || "";
        },
        showModal: {
            get() {
                return this.requestDeliveryModalVisible;
            },
            set(show) {
                if (show) {
                    this.showRequestDeliveryModal();
                } else {
                    this.hideRequestDeliveryModal();
                }
            },
        },
        sidebarLinks() {
            // get all the routes that should be included in the sidebar
            const linkRoutes = routes[0].children.filter((route) => {
                // don't include links that this user is not authorized to view
                // actual authorization checking is handled at the router & server level
                let authorized = true;
                if (route.meta && route.meta.requiredRoles) {
                    authorized = route.meta.requiredRoles.includes(
                        this.me.role,
                    );
                }
                return route.meta && route.meta.sidebar && authorized;
            });
            return linkRoutes.map((route) => {
                const children = route.children || [];
                return {
                    name: route.meta.sidebar.name,
                    icon: route.meta.sidebar.icon,
                    path: route.path,
                    children: children.filter(
                        (child) => child.meta && child.meta.sidebar,
                    ),
                };
            });
        },
    },
    async created() {
        try {
            this.me = await api.get("/me");
        } catch (error) {
            console.error(error);
        }
    },
    mounted() {
        const miniSidebar = JSON.parse(
            localStorage.getItem("settings_minisidebar") ?? "true",
        );

        if (miniSidebar) {
            this.$sidebar.minimize();
        } else {
            this.$sidebar.maximize();
        }
    },
    methods: {
        logout() {
            api.logout(false);
            this.$router.push({ name: "Login" });
        },
        async switchAccount(userId) {
            try {
                const response = await api.post(
                    "/account/current",
                    {
                        user_id: userId,
                    },
                    null,
                );
                api.storeAuthToken(response.token);
                window.location.reload();
            } catch (error) {
                console.error(error);
            }
        },
        ...mapActions("deliveryRequest", [
            "showRequestDeliveryModal",
            "hideRequestDeliveryModal",
            "cancelDeliveryRequest",
        ]),
    },
};
</script>
